import { Address } from '@adornis/address/db/address.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Names } from '@ils/static/names.js';

@Entity()
export class Location extends MongoEntity {
  static override _class = Names.Location._class;
  static override _collectionName = Names.Location._collectionName;

  @Field(type => String)
  displayName: Maybe<string>;

  @Field(type => Address)
  address: Maybe<Address>;

  override toString(): string {
    return `${this.displayName} (${this.address?.toString()})`;
  }
}
